import React from 'react';
import type { InviteTarget } from '../types';
import { toAbsoluteProfileUrl } from '@/utils/profileUtils';

interface SelectedUserBoxProps {
  selectedUsers: InviteTarget[];
  onRemove: (id: string) => void;
}

const SelectedUserBox: React.FC<SelectedUserBoxProps> = ({ selectedUsers, onRemove }) => {
  return (
    <div className="rtcOrganization__userBox scrollCustom">
      {selectedUsers.map((user) => {
        let iconMarkup = null;

        if (user.type === 'USER' || user.type === 'CONTACT') {
          const bgImage = toAbsoluteProfileUrl(user.profileUrl) || '';
          iconMarkup = (
            <div className="common_coProfileBox">
              <div 
                className="common_coProfileBox__imgBox"
                style={bgImage ? { backgroundImage: `url(${bgImage})` } : {}}
              />
            </div>
          );
        } else if (user.type === 'ORGANIZATION') {
          // 조직도 트리 아이콘
          iconMarkup = (
            <div className="common_coProfileBox common_coProfileBox--icon">
              <div 
                className="common_coProfileBox__imgBox"
                style={{ backgroundImage: 'url(https://static.wehago.com/imgs/rtc/ic_tree.png)' }}
              />
            </div>
          );
        } else {
          // 이메일 / 휴대폰 번호 외부 초대
          iconMarkup = (
            <div className="common_coProfileBox common_coProfileBox--icon" style={{ background: '#c1cbdd' }}>
              <div 
                className="common_coProfileBox__imgBox"
                style={{ backgroundImage: 'url(https://static.wehago.com/imgs/common/profile_icon_user.png)' }}
              />
            </div>
          );
        }

        return (
          <div key={user.id} className="rtcOrganization__userBoxTag">
            {iconMarkup}
            <span className="rtcOrganization__userBoxTag_name ellipsis">{user.name}</span>
            <button 
              type="button" 
              className="rtcOrganization__userBoxTag_delBtn"
              onClick={() => onRemove(user.id)}
            >
              <span className="blind">삭제</span>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default SelectedUserBox;
